import React from "react";
import { Navigate } from "react-router-dom";

import DRMRoutes from "../pages/DRM/DRMRoutes";
import QC_routes from "app/pages/QC_137/QC_routes";
import IDS_routes from "app/pages/IDS/IDS_routes";
import OA_routes from "app/pages/OA/OA_routes";
import DocgenRoutes from "app/pages/Docgen/DocgenRoutes";
import Collaboration_routes from "app/pages/CollaborationSpace/Collaboration_routes";
import TM_routes from "app/pages/TMKnockout/TM_routes";
import FileNumberGenerator_routes from "app/pages/fileNumberGenerator/FileNumberGeneratorRoutes";
import AdminLogin from "app/pages/superadmin/AdminLogin";
import Page from "@jumbo/shared/Page";
import TenantLogin from "app/pages/tenants/TenantLogin";
import TenantPasswordReset from "app/pages/tenants/TenantPasswordReset";
import tenantRoutes from "app/pages/tenants/tenantRoutes";
import superAdminRoutes from "app/pages/superadmin/superAdminRoutes";
import TenantUserInvite from "app/pages/tenants/TenantUserInvite";
import TrexoChatRoute from "app/pages/TrexoChat/TrexoChatRoute";
import Error404 from "app/pages/extra-pages/Error404";
import TenantCallback from "app/pages/tenants/TenantCallback";
import KotRoutes from "app/pages/Kot/KotRoute";
import DV_routes from "app/pages/DataVerification/DV_routes";
import ADIM_Routes from "app/pages/ADIM/ADIM_Routes";

/**
 routes which you want to make accessible to both authenticated and anonymous users
 **/
const routesForPublic = [];

/**
 routes only accessible to authenticated users
 **/
const routesForAuthenticatedOnly = [
    {
        path: "/",
        element: <Navigate to={"/dashboard"} />
    },
    ...tenantRoutes,
    ...superAdminRoutes,
    ...DRMRoutes,
    ...IDS_routes,
    ...QC_routes,
    ...OA_routes,
    ...DocgenRoutes,
    ...Collaboration_routes,
    ...TrexoChatRoute,
    ...FileNumberGenerator_routes,
    ...TM_routes,
    ...KotRoutes,
    ...DV_routes,
    ...ADIM_Routes
];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [
    {
        path: "/login",
        element: <Page component={TenantLogin} layout={"solo-page"} />
    },

    {
        path: "/login/callback",
        element: <Page component={TenantCallback} layout={"solo-page"} />
    },
  
    {
        path: "/superAdmin/login",
        element: <Page component={AdminLogin} layout={"solo-page"}/>
    },
    {
        path: "/reset-password",
        element: <Page component={TenantPasswordReset} layout={"solo-page"} />
    },

    {
        path: "/invite",
        element: <Page component={TenantUserInvite} />
    },
];

const routes = [
    ...routesForPublic,
    ...routesForAuthenticatedOnly,
    ...routesForNotAuthenticatedOnly,
    {
        path: "*",
        element: <Page component={Error404} layout={"solo-page"} />,
    }
];

export {routes as default, routesForPublic, routesForNotAuthenticatedOnly, routesForAuthenticatedOnly};
